import React from 'react';
import { AppBar, IconButton, Toolbar, Drawer, Stack } from '@mui/material';
import { styled, useTheme } from '@mui/material/styles';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import { templates } from '../../../modules/layoutPlantilla';
import Arbol from '../TreeSettings';
import Editor from '../LayoutEditor';

import useTimeStore from '../ZustandProvider';

const BotonEditor = props => {
  const { changeLoading, isPublicMap, map } = props;

  const data = useTimeStore(state => state.data);
  const [openEdit, setOpenEdit] = React.useState(false);
  const idMap = map._id;
  const theme = useTheme();

  const heightEditComponent = isPublicMap ? 0 : '56px';
  const heightLocal = window.innerWidth >= 500 ? heightEditComponent : '60%';
  const drawerWidthLocal = window.innerWidth >= 500 ? window.innerWidth / 4 : '100%';
  const handleDrawerToggle = () => {
    setOpenEdit(!openEdit);
  };
  if (isEmpty(map.templates)) {
    map.templates = templates;
  }

  const AppBarStyled = styled(AppBar, {
    shouldForwardProp: prop => prop !== 'open'
  })(({ open }) => ({
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    }),
    marginRight: 0,
    ...(open && {
      marginLeft: `${-drawerWidthLocal}px`,
      transition: theme.transitions.create(['margin', 'width'], {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen
      })
    })
  }));

  return (
    <>
      {isPublicMap ? null : (
        <>
          <AppBarStyled
            position="relative"
            open={openEdit}
            style={{
              backgroundColor: 'rgb(251, 192, 45, 0)',
              color: 'black',
              radio: 3
            }}
            elevation={0}
          >
            <Toolbar
              style={{
                direction: 'row',
                justifyContent: 'flex-end'
              }}
              disableGutters
            >
              <Stack>
                <IconButton
                  variant="contained"
                  style={{
                    backgroundColor: 'white',
                    color: '#2A3F90',
                    border: '1px solid',
                    borderColor: '#2A3F90'
                  }}
                  size="small"
                  aria-label="open drawer"
                  onClick={() => {
                    handleDrawerToggle();
                  }}
                  edge="start"
                >
                  <ModeEditOutlineOutlinedIcon />
                </IconButton>
              </Stack>
            </Toolbar>
          </AppBarStyled>
          <Drawer
            sx={{
              width: drawerWidthLocal,
              flexShrink: 0,
              '& .MuiDrawer-paper': {
                width: drawerWidthLocal,
                boxSizing: 'border-box',
                top: heightLocal
              }
            }}
            variant="persistent"
            anchor={window.innerWidth >= 500 ? 'right' : 'bottom'}
            open={openEdit}
          >
            <div>
              <Arbol
                data={data}
                idMap={idMap}
                templates={map.templates}
                changeLoading={changeLoading}
              />
              <Editor data={data} idMap={idMap} map={map} />
            </div>
          </Drawer>
        </>
      )}
    </>
  );
};

export default BotonEditor;
BotonEditor.defaultProps = {
  changeLoading: () => {},
  isPublicMap: false,
  map: {}
};
BotonEditor.propTypes = {
  changeLoading: PropTypes.func,
  isPublicMap: PropTypes.bool,
  map: PropTypes.object
};
